





















import {fieldProps} from '../BZCore/ActiveField'
import Vue from 'vue'
import Errors from '../errors.vue'
import UiInlineIcon from '../../Icon/InlineIcon.vue'
import NumberInput from '../../Inputs/NumberInput.vue'

export default Vue.extend({
  name: 'NumberField',
  props: fieldProps,
  components: {Errors, UiInlineIcon, NumberInput},
  created () {
    if (!this.value && this.defaultValue) {
      this.$emit('input', this.defaultValue)
    }
  },
  watch: {
    defaultValue (newValue, oldValue) {
      if (!this.value || this.value === oldValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onInput (event: string) {
      this.$emit('input', event)
    },
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
    }
  },
  computed: {
    currentValue: {
      get (): string {
        // @ts-ignore
        return this.value
      },
      set () {

      }
    }
  }
})
